import { DataGridComponent } from "../common/DataGridComponent";
import { ColumnType } from "../../types/dataGridTypes";
import { useConnector } from "./useConnector";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../store";
import { setConnectorDetails } from "../../store/slices/commonSlice";

const columns: ColumnType[] = [
  {
    field: "connector_id",
    headerName: "Connector ID",
    minWidth: 100,
    flex: 1,
    cmp: "link",
    linkPermission: "VIEW_STUDY_DETAILS",
  },
  {
    field: "name",
    headerName: "Name",
    minWidth: 100,
    flex: 1,
  },
  {
    field: "study_ids",
    headerName: "Studies",
    minWidth: 100,
    flex: 1,
  },
];

const ConnectorsList = () => {
  const [rows, setRows] = useState([]);
  const [rowsCount, setRowsCount] = useState(0);
  const navigate = useNavigate();
  const { refetchGetAllConnectors, getAllConnectorsData, getConnectorDetails } =
    useConnector();
  const dispatch = useAppDispatch();
  useEffect(() => {
    refetchGetAllConnectors();
  }, []);

  useEffect(() => {
    if (getAllConnectorsData?.length > 0) {
      const data = getAllConnectorsData.map((item: any) => {
        return { ...item, id: item.connector_id };
      });
      setRows(data);
      setRowsCount(data?.length);
    } else {
      setRows([]);
      setRowsCount(0);
    }
  }, [getAllConnectorsData]);

  const handleClickConnectorId = async (connector: any) => {
    const response: any = await getConnectorDetails({
      connector_id: connector?.connector_id,
    });
    if (response?.data) {
      const resJson = response?.data?.[0];
      dispatch(
        setConnectorDetails({
          ...resJson,
          ...resJson?.primary_system,
          password: "********",
          secondary_mode: resJson?.secondary_system?.mode,
          secondary_data_format: resJson?.secondary_system?.data_format,
          secondary_base_url: resJson?.secondary_system?.base_url,
          secondary_base_api_path: resJson?.secondary_system?.base_api_path,
          secondary_username: resJson?.secondary_system?.username,
          secondary_password: "********",
          secondary_study_json_path: resJson?.secondary_system?.study_json_path,
          secondary_study_file_id: resJson?.secondary_system?.study_file_id,
          secondary_mapping_id: resJson?.secondary_system?.mapping_id,
          secondary_token_url: resJson?.secondary_system?.token_url,
          secondary_base_folder_path:
            resJson?.secondary_system?.base_folder_path,
          secondary_sftp_host: resJson?.secondary_system?.sftp_host,
          secondary_sftp_port: resJson?.secondary_system?.sftp_port,
        })
      );
    }
    navigate(
      `/configuration/connectors/${encodeURIComponent(connector?.connector_id)}`
    );
  };
  const actions = {
    connector_id: (data: any) => {
      handleClickConnectorId(data);
    },
  };

  return (
    <DataGridComponent
      autoHeight
      columns={columns as any}
      hasDefinedColumns={false}
      rows={rows}
      rowsCount={rowsCount}
      actions={actions}
    />
  );
};

export default ConnectorsList;
